export const BASE_CLASS = 'mt-CardCertification'
